import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { ActividadesSolicitudDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class ActividadesSolicitudService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getActividadesSolicitudPorSolicitudService(codigo: string): Observable<BodyListResponse<ActividadesSolicitudDTO>> {
    return this.http.get<BodyListResponse<ActividadesSolicitudDTO>>(API_URL + '/api/v1/actividadesSolicitud/solicitud/' + codigo);
  }

  getActividadesSolicitudService(): Observable<BodyListResponse<ActividadesSolicitudDTO>> {
    return this.http.get<BodyListResponse<ActividadesSolicitudDTO>>(API_URL + '/api/v1/actividadesSolicitud/todos');
  }

  guardarActividadesSolicitudService(actividadesSolicitudDTO: ActividadesSolicitudDTO): Observable<BodyResponse<ActividadesSolicitudDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/actividadesSolicitud', actividadesSolicitudDTO);
  }

  getActividadesSolicitudPorCodigoActividadSolicitudService(codigoActividadSolicitud: string): Observable<BodyResponse<ActividadesSolicitudDTO>> {
    return this.http.get<BodyResponse<ActividadesSolicitudDTO>>(API_URL + '/api/v1/actividadesSolicitud/' + codigoActividadSolicitud);
  }
}
